import * as React from 'react'
import { connect } from 'react-redux'
import { Footer } from '../online/footer'
import { preHideNotification } from '../../actions/notification'
import { changeNavigationStack } from '../../actions/navigation'
import { RootState } from '../../types/rootstate'
import { resizingComponent } from '../resizingcomponent'

import '../../sass/online/proactiveMessage.scss'
import { strings } from '../../lib/localization'

const APPEND_NOTIFICATION_HEIGHT = 16

interface StateProps {
  notification: RootState['notification']
  agentName: string
  agentPicture: string
}

interface DispatchProps {
  hideNotification: (reason: string) => void
  navigateToOnline: () => void
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface OwnProps {}

type OnlineNotificationProps = StateProps & DispatchProps & OwnProps

function mapStateToProps(state: RootState): StateProps {
  return {
    notification: state.notification,
    agentName: state.activeConversation.agentName,
    agentPicture: state.activeConversation.agentPicture
  }
}

function mapDispatchToProps(dispatch): DispatchProps {
  return {
    hideNotification: (reason) => dispatch(preHideNotification(reason)),
    navigateToOnline: () => dispatch(changeNavigationStack('online'))
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface OnlineNotificationState {}

class OnlineNotificationComponent extends React.Component<
  OnlineNotificationProps,
  OnlineNotificationState
> {
  componentDidUpdate() {
    this.addImgListeners()
  }

  updateDimensions = () => {
    resizingComponent.dimensionsUpdated(0, APPEND_NOTIFICATION_HEIGHT)
  }

  componentDidMount() {
    this.updateDimensions()
    this.addImgListeners()
  }

  componentWillUnmount() {
    const imgs = document.querySelectorAll('.imbox-message-block-paragraph img')

    for (let i = 0; i < imgs.length; ++i) {
      imgs[i].removeEventListener('load', this.updateDimensions)
    }
  }

  addImgListeners() {
    const imgs = document.querySelectorAll('.imbox-message-block-paragraph img')

    for (let i = 0; i < imgs.length; ++i) {
      imgs[i].removeEventListener('load', this.updateDimensions)
      imgs[i].addEventListener('load', this.updateDimensions)
    }
  }

  handleAfterSendMessage = () => {
    this.props.hideNotification('startChat')
    this.props.navigateToOnline()
  }

  handleFooterOnChange = () => {
    this.updateDimensions()
  }

  closeNotification = () => {
    this.props.hideNotification('close')
  }

  handleCloseKeyDown = (e: React.KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.props.hideNotification('close')
    }
  }

  render() {
    const content = {
      __html: this.props.notification.message
    }

    return (
      <div
        ref={(node) => resizingComponent.setRef(node, 'notification')}
        className='imbox-notification'
      >
        <div className='imbox-message-frame'>
          <div className='imbox-message-part first'>
            <div className='imbox-message-container agent'>
              <div className='imbox-message-container-avatar'>
                <div className='imbox-avatar'>
                  <img
                    className='avatar'
                    src={this.props.agentPicture}
                    alt=''
                  />
                </div>

                {this.props.agentName && (
                  <span className='name'>{this.props.agentName}</span>
                )}

                <span
                  className='notification-close'
                  // eslint-disable-next-line react/jsx-handler-names
                  onClick={this.closeNotification}
                  role='button'
                  onKeyDown={this.handleCloseKeyDown}
                  tabIndex={0}
                  aria-label={strings.a11yNotificationClose}
                >
                  <i className='icon-close material-icons'>
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              {this.props.notification.message && (
                <div className='imbox-message '>
                  <div className='imbox-message-block'>
                    <div
                      className='imbox-message-block-paragraph'
                      dangerouslySetInnerHTML={content}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <Footer
          // eslint-disable-next-line react/jsx-handler-names
          afterSendMessage={this.handleAfterSendMessage}
          onChange={this.handleFooterOnChange}
        />
      </div>
    )
  }
}

const OnlineNotification = connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(OnlineNotificationComponent)

export { OnlineNotification }
